// External Dependencies
import React from 'react';
import PropTypes from 'prop-types';
import { grey200 } from 'material-ui/styles/colors';

// Local Variables
const propTypes = {
  children: PropTypes.node,
  padding: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  width: PropTypes.number,
};

const defaultProps = {
  children: null,
  padding: '',
  width: 0,
};

const defaultRootStyles = {
  borderRight: `solid 1px ${grey200}`,
  display: 'flex',
  flex: 'none',
  flexDirection: 'column',
  padding: '8px 0',
  width: 320,
};

// Component Definition
const Nav = (props) => {
  const {
    children,
    padding,
    width,
  } = props;

  // Don't render anything if there are no children
  if (!children) return null;

  const rootStyles = width || padding
    ? {
      ...defaultRootStyles,
      padding: padding || '8px 0',
      width: width || 320,
    }
    : defaultRootStyles;

  return <div style={rootStyles}>{children}</div>;
};

Nav.propTypes = propTypes;
Nav.defaultProps = defaultProps;
export default Nav;



/** WEBPACK FOOTER **
 ** ./src/shared/main-content-container/nav.js
 **/